/** Where an offer to work stands on the household's phone. */
export const OfferState = { open: "open", asked: "asked", declined: "declined" };
//# sourceMappingURL=types.js.map